export default __webpack_public_path__ + "static/media/404.9616d593.png";